<template>
  <div class="rightCompany">
    <header>
      <h1>我的企业</h1>
      <div class="more">
        <span>更多</span>
        <i class="el-icon-arrow-right" />
      </div>
    </header>
    <div class="content">
      <img src="../../images/icondefault_company@2x.png" />
      <div class="company-name">
        <span class="text">{{ corporationInfo.companyName }}</span>
        <img v-if="corpCertityStatus" src="../../images/verified@2x.png" />
        <img v-if="!corpCertityStatus" src="../../images/verified_un@2x.png" />
      </div>
      <el-button
        v-if="companyList.length > 1"
        type="primary"
        icon="el-icon-refresh"
        @click="handleSwitchClick"
      >
        切换企业
      </el-button>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    companyList() {
      return this.$store.state.companyList;
    },
    corpCertityStatus() {
      return this.$store.state.corpCertityStatus;
    },
    userCertityStatus() {
      return this.$store.state.userCertityStatus;
    },
    corporationInfo() {
      return this.$store.state.corporationInfo;
    },
  },
  watch: {
    corporationInfo: {
      handler(v) {
        this.$store.commit('updateCorporationInfo', v);
      },
      deep: true,
    },
  },
  methods: {
    handleSwitchClick() {
      this.$store.commit('updateCompanyModal', true);
    },
  },
};
</script>
<style lang="scss" scoped>
@import url('./right.css');
.content {
  padding: 33px 42px 62px;
  position: relative;
  height: 173px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 1);
  img {
    width: 37px;
    height: 37px;
    display: block;
    margin-bottom: 30px;
  }
  .company-name {
    font-size: 20px;
    font-weight: 500;
    color: rgba(18, 28, 64, 1);
    line-height: 28px;
    margin-bottom: 21px;
    display: flex;
    span {
      position: relative;
      padding-right: 10px;
      color: #181818 !important;
    }
    img {
      width: 58.5px;
      height: 17.5px;
      display: inline-block;
      margin-top: 5px;
      cursor: zoom-in;
    }
  }
  p {
    font-size: 13px;
    font-weight: 400;
    color: rgba(120, 127, 149, 1);
    line-height: 18px;
    margin-bottom: 7px;
  }
  .el-button--primary {
    position: absolute;
    right: 20px;
    bottom: 21px;
    padding: 7px 9px;
    font-size: 14px;
    color: rgba(255, 255, 255, 1);
    background: rgba(50, 51, 82, 1) !important;
    border-radius: 4px;
  }
}
</style>
